var indexOf = [].indexOf;

angular.module('gym.membership-plans').controller('ShowMembershipPlansCtrl', ["$scope", "$state", "$window", "$filter", "$q", "$timeout", "$modal", "flash", "loadingAnimation", "isInteger", "MembershipIntervalUnits", "EventService", "MembershipPlanService", "FeatureNamesService", "WebsiteResource", "gym", "membershipPlan", "membershipPlanCategories", "gradingStyles", function($scope, $state, $window, $filter, $q, $timeout, $modal, flash, loadingAnimation, isInteger, MembershipIntervalUnits, EventService, MembershipPlanService, FeatureNamesService, WebsiteResource, gym, membershipPlan, membershipPlanCategories, gradingStyles) {
  var isPaymentOnlyPlan, reloadPlan, website;
  $scope.gym = gym.attributes;
  $scope.membershipPlan = membershipPlan;
  $scope.membershipPlanCategories = membershipPlanCategories;
  $scope.membership_interval_units = MembershipIntervalUnits;
  $scope.gradingStyles = gradingStyles;
  $scope.currency_symbol = gym.attributes.currency_symbol;
  $scope.isMartialArts = gym.attributes.is_martial_arts;
  website = WebsiteResource.doGET().$object;
  EventService.eventTypesWithDeleted($scope.membershipPlan.event_type_ids).then(function(eventTypes) {
    $scope.eventTypes = eventTypes;
    return $scope.selectedTypes = _.chain(eventTypes).filter(function(type) {
      var ref;
      return ref = type.id, indexOf.call($scope.membershipPlan.event_type_ids, ref) >= 0;
    }).pluck('name').value().join(', ');
  });
  $scope.selectedStyles = _.chain(gradingStyles).filter(function(style) {
    var ref;
    return ref = style.id, indexOf.call($scope.membershipPlan.style_ids, ref) >= 0;
  }).pluck('name').value().join(', ');
  $scope.bookAndPayAllowedLabel = function() {
    var plan;
    plan = membershipPlan;
    if (!plan.event_type_ids.length && plan.book_and_pay_allowed) {
      return 'Payment Only Checkout enabled';
    } else {
      return 'Book and Pay Checkout enabled';
    }
  };
  $scope.memberPortalOrMobileAppEnabled = $scope.gym.mobile_app_enabled || $scope.gym.member_portal_enabled;
  $scope.memberPortalLabel = FeatureNamesService.memberPortal();
  $scope.bookAndPayUrl = function() {
    return `${window.location.protocol}//${window.location.host}${$scope.membershipPlan.book_and_pay_url}`;
  };
  $scope.bookAndPayPaymentOnlyUrl = function() {
    return `${window.location.protocol}//${window.location.host}${$scope.membershipPlan.book_and_pay_payment_only_url}`;
  };
  $scope.savePlan = function() {
    return $scope.membershipPlan.save().then(function(plan) {
      return $scope.membershipPlan = plan;
    });
  };
  $scope.bookAndPayAvailable = function() {
    return $scope.membershipPlan.restrict_access_by_event_type && !$scope.membershipPlan.specified_start_date;
  };
  $scope.onCopied = function() {
    $scope.copied = true;
    return $timeout(function() {
      return $scope.copied = false;
    }, 1500);
  };
  $scope.onPaymentOnlyCopied = function() {
    $scope.paymentOnlyCopied = true;
    return $timeout(function() {
      return $scope.paymentOnlyCopied = false;
    }, 1500);
  };
  $scope.manageTypes = function() {
    return $modal.open({
      template: require('templates/gyms/calendar/events/manage_types.html.slim'),
      controller: 'ManageEventTypesModal'
    });
  };
  $scope.save = function() {
    return MembershipPlanService.validate($scope.membershipPlan).then(function() {
      loadingAnimation.show();
      return $scope.membershipPlan.save().then(function() {
        flash.success = `${membershipPlan.label} saved`;
        return $state.go('^.list');
      }, function(response) {
        $scope.membershipPlan.errors = response.data.errors;
        return loadingAnimation.hide();
      });
    });
  };
  $scope.isFormValid = function() {
    var plan;
    plan = $scope.membershipPlan;
    return (plan.classes_unlimited || isInteger(plan.classes_limit) && plan.classes_limit >= 0) && (!plan.cost_upfront || plan.cost_upfront > 0) && plan.classes_interval_number >= 0 && plan.cost_repeat >= 0 && (plan.plan_type === 'upfront' || plan.charge_interval_number >= 1) && (!plan.term_number || plan.term_number > 0) && (!plan.perform_automatic_reschedule || (plan.automatic_reschedule_days >= 1 && plan.automatic_reschedule_days <= 30)) && (!plan.automatic_reschedule_limit || (plan.automatic_reschedule_limit >= 1 && plan.automatic_reschedule_limit <= 10));
  };
  $scope.scheduleInitialPayment = function() {
    var interval;
    if (!(membershipPlan.cost_upfront >= 0)) {
      return null;
    }
    switch (membershipPlan.default_upfront_date_strategy) {
      case 'charge_upfront_amount_on_start_date':
        return 'Membership start date';
      case 'charge_upfront_amount_asap':
        return 'As soon as possible';
      case 'charge_upfront_amount_relative_to_start_date':
        interval = $filter('pluralize')(membershipPlan.relative_upfront_date_unit, membershipPlan.relative_upfront_date_number, true);
        return `${interval} ${membershipPlan.relative_upfront_date_direction} membership starts`;
    }
  };
  $scope.repeatingPaymentStart = function() {
    var interval, occasion;
    if (!(membershipPlan.cost_repeat >= 0)) {
      return null;
    }
    switch (membershipPlan.default_repeat_date_strategy) {
      case 'start_repeat_payments_one_period_after_upfront':
        interval = $filter('pluralize')(membershipPlan.charge_interval_unit, membershipPlan.charge_interval_number, true);
        return `${interval} after initial payment`;
      case 'start_repeat_payments_relative_to_start_or_upfront':
        interval = $filter('pluralize')(membershipPlan.relative_repeat_date_unit, membershipPlan.relative_repeat_date_number, true);
        occasion = membershipPlan.cost_upfront >= 0 ? "initial payment" : "membership starts";
        return `${interval} after ${occasion}`;
      case 'start_repeat_payments_on_membership_start_date':
        return 'Membership start date';
    }
  };
  reloadPlan = function() {
    return $scope.membershipPlan.get().then(function(plan) {
      return $scope.membershipPlan = plan;
    });
  };
  $scope.manageBookAndPay = function() {
    var modalInstance;
    modalInstance = $modal.open({
      template: require('templates/gyms/membership_plans/manage_membership_plan_book_and_pay_modal.html.slim'),
      resolve: {
        plan: function() {
          return $scope.membershipPlan.clone();
        }
      },
      controller: 'ManageMembershipPlanBookAndPayCtrl'
    });
    return modalInstance.result.then(function() {
      return reloadPlan();
    });
  };
  isPaymentOnlyPlan = function(plan) {
    var ref;
    plan = $scope.membershipPlan;
    return ((ref = plan.default_start_date_strategy) === 'start_on_next_upcoming' || ref === 'start_relative_to_purchase_date') || plan.specified_start_date || !plan.restrict_access_by_event_type;
  };
  $scope.getSampleUrl = function(plan) {
    var poParam;
    plan = $scope.membershipPlan;
    poParam = isPaymentOnlyPlan(plan) ? '?ct=po' : '';
    return `/websites/${website != null ? website.domain : void 0}/book_and_pay/offers/${plan.uuid}/carts/sample_complete${poParam}`;
  };
  return $scope.cancel = function() {
    return $state.go('gym.membership-plans.list');
  };
}]);
